/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AiSummaryCardReferenceMeta
 */
export interface AiSummaryCardReferenceMeta {
    /**
     * 
     */
    outcome: AiSummaryCardReferenceMetaOutcomeEnum;
    /**
     * 
     */
    title_label: string;
    /**
     * 
     */
    category_label: string;
    /**
     * 
     */
    body: string;
    /**
     * 
     */
    secondary_body?: string;
}


/**
 * @export
 */
export const AiSummaryCardReferenceMetaOutcomeEnum = {
    Yes: 'YES',
    No: 'NO',
    Unresolved: 'UNRESOLVED',
} as const;
export type AiSummaryCardReferenceMetaOutcomeEnum = typeof AiSummaryCardReferenceMetaOutcomeEnum[keyof typeof AiSummaryCardReferenceMetaOutcomeEnum];


/**
 * Check if a given object implements the AiSummaryCardReferenceMeta interface.
 */
export function instanceOfAiSummaryCardReferenceMeta(value: object): value is AiSummaryCardReferenceMeta {
    if (!('outcome' in value) || value['outcome'] === undefined) return false;
    if (!('title_label' in value) || value['title_label'] === undefined) return false;
    if (!('category_label' in value) || value['category_label'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function AiSummaryCardReferenceMetaFromJSON(json: any): AiSummaryCardReferenceMeta {
    return AiSummaryCardReferenceMetaFromJSONTyped(json, false);
}

export function AiSummaryCardReferenceMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiSummaryCardReferenceMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'outcome': json['outcome'],
        'title_label': json['title_label'],
        'category_label': json['category_label'],
        'body': json['body'],
        'secondary_body': json['secondary_body'] == null ? undefined : json['secondary_body'],
    };
}

export function AiSummaryCardReferenceMetaToJSON(json: any): AiSummaryCardReferenceMeta {
    return AiSummaryCardReferenceMetaToJSONTyped(json, false);
}

export function AiSummaryCardReferenceMetaToJSONTyped(value?: AiSummaryCardReferenceMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outcome': value['outcome'],
        'title_label': value['title_label'],
        'category_label': value['category_label'],
        'body': value['body'],
        'secondary_body': value['secondary_body'],
    };
}

